import sysOut from '../../data/sysOut';

const state = {
    news: sysOut.news,
}

const mutations = {
}

const actions = {
}

const getters = {
    news: state => {
        return state.news;
    },
    newsList: state => {
        return Object.keys(state.news);
    },
    homeNews: state => {
        let arr = Object.keys(state.news);
        let arrLen = arr.length;
        if (arrLen > 2) {
            return arr.slice(arrLen-2);
        } else {
            return arr;
        }
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}